import { AppUtils } from '../../../../../shared/utils/index';
import { FahrzeugModel } from '../../../../../shared/models/view/Fahrzeug';

export class AppFormModel {
	private fahrzeug?: FahrzeugModel;

	constructor() {
		this.Fahrzeug = new FahrzeugModel();
	}

	set Fahrzeug(value: FahrzeugModel) {
		this.fahrzeug = value;
	}

	get Fahrzeug(): FahrzeugModel {
		return this.fahrzeug;
	}



	private baureihenGenerationen = new Array<BaureiheGenerationWithKeyApi>();
	private modellVarianten = new Array<ModellVarianteWithKeyApi>();
	private fahrzeuge = new Array<FahrzeugWithKeyApi>();

	public get BaureihenGenerationen(): Array<BaureiheGenerationWithKeyApi> {
		return this.baureihenGenerationen;
	}
	public set BaureihenGenerationen(value: Array<BaureiheGenerationWithKeyApi>) {
		this.baureihenGenerationen = value;
	}

	public get ModellVarianten(): Array<ModellVarianteWithKeyApi> {
		return this.modellVarianten;
	}
	public set ModellVarianten(value: Array<ModellVarianteWithKeyApi>) {
		this.modellVarianten = value;
	}

	public get Fahrzeuge(): Array<FahrzeugWithKeyApi> {
		return this.fahrzeuge;
	}
	public set Fahrzeuge(value: Array<FahrzeugWithKeyApi>) {
		this.fahrzeuge = value;
	}

	private warningEmptyPlateWasSeen: boolean;

	set WarningEmptyPlateWasSeen(value: boolean) {
		this.warningEmptyPlateWasSeen = value;
	}

	get WarningEmptyPlateWasSeen(): boolean {
		return this.warningEmptyPlateWasSeen;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): AppFormModel {
		return AppUtils.Helper.createFromMap(dataObject, AppFormModel, (key: string, value: any) => {
			switch (key) { //NOSONAR
				case 'fahrzeug':
					return FahrzeugModel.createFromObject(value);
				default:
					return value;
			}
		});
	}
}
